// extracted by mini-css-extract-plugin
export default {"form":"HCOvBy9VBW8OsaJFAA52"};